import axios from "axios";

const BUILD_TIME_BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Resolve the backend URL at request time, not build time. If the page is
// being served from a domain that differs from the build-time REACT_APP_BACKEND_URL
// (custom-domain deployment scenario), we MUST call the same origin so that
// httpOnly auth cookies set by /api/auth/login are scoped to the user's
// current domain. Otherwise login returns 200 but the cookie is dropped.
function resolveBackendUrl() {
    if (typeof window === "undefined") return BUILD_TIME_BACKEND;
    const currentOrigin = window.location.origin;
    if (!BUILD_TIME_BACKEND) return currentOrigin;
    try {
        const buildOrigin = new URL(BUILD_TIME_BACKEND).origin;
        return buildOrigin === currentOrigin ? BUILD_TIME_BACKEND : currentOrigin;
    } catch {
        return currentOrigin;
    }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

// Helper for inline view / download links. Resolves to the current domain so
// auth cookies are actually sent. Never use process.env.REACT_APP_BACKEND_URL
// directly in <a href> or <img src>.
export const fileUrl = (fileId) => `${API}/files/${fileId}/download`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiError(detail, err) {
    if (detail == null) {
        // When the backend response has no `detail`, surface as much context as
        // possible so production issues are diagnosable from a screenshot.
        if (err) {
            const status = err.response?.status;
            const statusText = err.response?.statusText;
            const bodyText = typeof err.response?.data === "string" ? err.response.data.slice(0, 120) : "";
            if (status) return `Request failed (${status}${statusText ? " " + statusText : ""})${bodyText ? " — " + bodyText : ""}`;
            if (err.message) return err.message;
        }
        return "Something went wrong. Please try again.";
    }
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
